import React from 'react';
import { Package, Beaker, Factory, Pill } from 'lucide-react';
import { mockData } from '../mock';

const getProductIcon = (name) => {
  if (name.includes('Food')) return <Package size={24} />;
  if (name.includes('Industrial')) return <Factory size={24} />;
  if (name.includes('Pharmaceutical')) return <Pill size={24} />;
  return <Beaker size={24} />;
};

export const Products = () => {
  return (
    <section id="products" className="products-section">
      <div className="container">
        <div className="section-header">
          <h2 className="heading-1 text-center mb-4">
            {mockData.products.title}
          </h2>
          <p className="body-large text-center mb-8" style={{maxWidth: '600px', margin: '0 auto 48px'}}>
            Premium quality guar gum products tailored for diverse industrial applications with consistent performance and reliability.
          </p>
        </div>
        
        <div className="network-grid">
          {mockData.products.items.map((product, index) => (
            <div key={index} className="network-card product-card">
              <div className="product-header">
                <div className="product-icon">
                  {getProductIcon(product.name)}
                </div>
                <h3 className="heading-3 mb-4">{product.name}</h3>
              </div>
              
              <p className="body-medium mb-6">{product.description}</p>
              
              <div className="product-specs">
                <h4 className="spec-title">Applications:</h4>
                <div className="spec-list">
                  {product.applications.map((app, idx) => (
                    <span key={idx} className="spec-tag">{app}</span>
                  ))}
                </div>
              </div>
              
              <div className="product-details">
                {product.purity && (
                  <div className="detail-item">
                    <span className="detail-label">Purity:</span>
                    <span className="detail-value">{product.purity}</span>
                  </div>
                )}
                {product.mesh && (
                  <div className="detail-item">
                    <span className="detail-label">Mesh Size:</span>
                    <span className="detail-value">{product.mesh}</span>
                  </div>
                )}
                {product.viscosity && (
                  <div className="detail-item">
                    <span className="detail-label">Viscosity:</span>
                    <span className="detail-value">{product.viscosity}</span>
                  </div>
                )}
                {product.compliance && (
                  <div className="detail-item">
                    <span className="detail-label">Compliance:</span>
                    <span className="detail-value">{product.compliance}</span>
                  </div>
                )}
              </div>
              
              <div className="product-cta">
                {/* <button className="btn-primary w-full">Request Sample</button> */}
                <a href="#contact" className="btn-primary w-full" style={{ display: 'inline-block', textAlign: 'center' }}>
    Request Sample
  </a>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

// Product Styles
const styles = `
.products-section {
  background: white;
  padding: var(--spacing-giant) 0;
}

.product-card {
  display: flex;
  flex-direction: column;
  height: 100%;
}

.product-header {
  display: flex;
  align-items: flex-start;
  gap: 16px;
  margin-bottom: 20px;
}

.product-icon {
  background: var(--bg-subtle);
  padding: 12px;
  border-radius: 16px;
  color: var(--brand-dark);
  flex-shrink: 0;
}

.product-specs {
  margin-bottom: 24px;
}

.spec-title {
  font-size: 16px;
  font-weight: 600;
  color: var(--text-primary);
  margin-bottom: 12px;
}

.spec-list {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.spec-tag {
  background: var(--brand-primary);
  color: var(--text-primary);
  padding: 6px 12px;
  border-radius: 15px;
  font-size: 12px;
  font-weight: 500;
}

.product-details {
  border-top: 1px solid var(--border-light);
  padding-top: 20px;
  margin-bottom: 24px;
  flex-grow: 1;
}

.detail-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 8px 0;
  border-bottom: 1px solid var(--border-light);
}

.detail-item:last-child {
  border-bottom: none;
}

.detail-label {
  font-size: 14px;
  color: var(--text-light);
  font-weight: 500;
}

.detail-value {
  font-size: 14px;
  color: var(--text-primary);
  font-weight: 600;
}

.product-cta {
  margin-top: auto;
}

.w-full {
  width: 100%;
}

@media (max-width: 781px) {
  .product-header {
    flex-direction: column;
    text-align: center;
  }
  
  .product-icon {
    align-self: center;
  }
}
`;

// Inject styles
if (typeof document !== 'undefined') {
  const styleSheet = document.createElement('style');
  styleSheet.textContent = styles;
  document.head.appendChild(styleSheet);
}